import { Component, OnInit, Inject } from '@angular/core';
import { AlertifyService } from '../_service/alertify.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { UserService } from '../_service/user.service';

@Component({
  selector: 'resendEmail',
  templateUrl: './resendEmail.component.html',
  styleUrls: ['./resendEmail.component.css']
})
export class ResendEmailComponent implements OnInit {
  model: any = {};
  emailSent: any = [];
  isExist: any = {};

  constructor(private userService: UserService,
    private router: Router,
     private alertify: AlertifyService,
     private dialog: MatDialog,
     @Inject(MAT_DIALOG_DATA) public passedData: any,
     ) { }
     userOutsideId = this.passedData.user.userOutsideId;
     email = this.passedData.user.emailAddress;

  ngOnInit() {
  }

  resendConfirmationEmail() {
    return this.userService.resendUserEmail(this.email).subscribe(
      res => {
        this.emailSent = res.headers.get('emailresent');
        this.isExist = res.headers.get('noUserFound');
        if (this.emailSent) {
          this.alertify.success(this.emailSent);
          this.dialog.closeAll();
        } else if (this.isExist) {
          this.alertify.message(this.isExist);
        }
      },
      error => {
        this.alertify.error('Something is not quite right');
      }
    );
  }
}